import React from "react";
import TrustUs from "../assets/images/trustus.jpg";
import SeconadaryBtn from "../components/SeconadaryBtn.jsx";
import DoubleTick from "../assets/icons/doubletick.svg";

export default function WhyTrust() {
  return (
    <div className="whyTrust_container">
      <div className="whyTrust_contentWrapper">
        {/* Left Image Section */}
        <div className="whyTrust_left">
          <img
            src={TrustUs}
            alt="Doctor consultation"
            className="whyTrust_image"
          />

          {/* 24/7 Badge */}
          <div className="whyTrust_badge">
            <div className="whyTrust_badgeNumber">24/7</div>
            <div className="whyTrust_badgeText">Support</div>
          </div>
        </div>

        {/* Right Content Section */}
        <div className="whyTrust_right">
          <h2 className="whyTrust_title">Why Families Trust VeriMED</h2>

          <ul className="whyTrust_list">
            {[
              "Licensed Physicians & Nurses",
              "Real-Time Updates",
              "Comprehensive Services",
              "Our team is always just a call or message away.",
              "Secure & Compliant",
            ].map((item, index) => (
              <li key={index} className="whyTrust_listItem">
                <img src={DoubleTick} alt="check" className="whyTrust_icon" />
                <span className="whyTrust_listText">{item}</span>
              </li>
            ))}
          </ul>

          <SeconadaryBtn label="Book an Appointment" onClick={() => {}} />
        </div>
      </div>
    </div>
  );
}
